import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function selectYourXIndexReducer(state = initialState.selectYourXIndex, action) {
    switch (action.type) {
        case types.SELECT_YOUR_X_INDEX_CHANGED:
            return ((action.dropdownIndex < initialState.selectYourXDropdowns.length - 1) ? (action.dropdownIndex + 1) : state);
        case types.RESET_FORM_TO_DEFAULT:
            return 0;
        default:
            return state;
    }
}